import { render, staticRenderFns } from "./family-economy.vue?vue&type=template&id=09992cd9&scoped=true&"
import script from "./family-economy.vue?vue&type=script&lang=js&"
export * from "./family-economy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09992cd9",
  null
  
)

export default component.exports